var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftGray400(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4652_7213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 7,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5832 14.4165C13.9165 14.7498 13.9165 15.2498 13.5832 15.5832C13.4165 15.7498 13.2498 15.8332 12.9998 15.8332C12.7498 15.8332 12.5832 15.7498 12.4165 15.5832L7.4165 10.5832C7.08317 10.2498 7.08317 9.74984 7.4165 9.4165L12.4165 4.4165C12.7498 4.08317 13.2498 4.08317 13.5832 4.4165C13.9165 4.74984 13.9165 5.24984 13.5832 5.58317L9.1665 9.99984L13.5832 14.4165Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4652_7213)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0.5)",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#888888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftGray400);
export default __webpack_public_path__ + "static/media/chevron_left_gray400.f6375fbf99b2cc4ea738c73dc0c3b680.svg";
export { ForwardRef as ReactComponent };